module.exports = __webpack_public_path__ + "img/housetech.6cb9d37b.png";